"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildScrollBar = exports.ShelfScrollBar = void 0;

var _themeGet = require("@styled-system/theme-get");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useMutationObserver = require("../../utils/useMutationObserver");

var _Box = require("../Box");

var _Clickable = require("../Clickable");

var _useClickScroll = require("./useClickScroll");

var _useDragScroll = require("./useDragScroll");

var _excluded = ["viewport"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * A synthetic scrollbar
 */


var ShelfScrollBar = /*#__PURE__*/_react.default.memo(function (_ref) {
  var _viewport$scrollLeft, _viewport$scrollWidth, _viewport$clientWidth, _trackRef$current$cli, _trackRef$current;

  var viewport = _ref.viewport,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)({
    scrollLeft: (_viewport$scrollLeft = viewport === null || viewport === void 0 ? void 0 : viewport.scrollLeft) !== null && _viewport$scrollLeft !== void 0 ? _viewport$scrollLeft : 0,
    scrollWidth: (_viewport$scrollWidth = viewport === null || viewport === void 0 ? void 0 : viewport.scrollWidth) !== null && _viewport$scrollWidth !== void 0 ? _viewport$scrollWidth : 1,
    clientWidth: (_viewport$clientWidth = viewport === null || viewport === void 0 ? void 0 : viewport.clientWidth) !== null && _viewport$clientWidth !== void 0 ? _viewport$clientWidth : 1
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      scrollLeft = _useState2$.scrollLeft,
      scrollWidth = _useState2$.scrollWidth,
      clientWidth = _useState2$.clientWidth,
      setScrollState = _useState2[1];

  var trackRef = (0, _react.useRef)(null);
  var thumbRef = (0, _react.useRef)(null);
  var trackWidth = (_trackRef$current$cli = (_trackRef$current = trackRef.current) === null || _trackRef$current === void 0 ? void 0 : _trackRef$current.clientWidth) !== null && _trackRef$current$cli !== void 0 ? _trackRef$current$cli : 1;

  var _buildScrollBar = buildScrollBar({
    trackWidth: trackWidth,
    scrollLeft: scrollLeft,
    scrollWidth: scrollWidth,
    clientWidth: clientWidth
  }),
      progress = _buildScrollBar.progress,
      requiresScrolling = _buildScrollBar.requiresScrolling,
      thumbOffset = _buildScrollBar.thumbOffset,
      thumbWidth = _buildScrollBar.thumbWidth; // Update scrollState on scroll and resize


  (0, _react.useEffect)(function () {
    if (!viewport) return;

    var updateScrollState = function updateScrollState() {
      var _viewport$scrollLeft2, _viewport$scrollWidth2, _viewport$clientWidth2;

      setScrollState({
        scrollLeft: (_viewport$scrollLeft2 = viewport === null || viewport === void 0 ? void 0 : viewport.scrollLeft) !== null && _viewport$scrollLeft2 !== void 0 ? _viewport$scrollLeft2 : 0,
        scrollWidth: (_viewport$scrollWidth2 = viewport === null || viewport === void 0 ? void 0 : viewport.scrollWidth) !== null && _viewport$scrollWidth2 !== void 0 ? _viewport$scrollWidth2 : 1,
        clientWidth: (_viewport$clientWidth2 = viewport === null || viewport === void 0 ? void 0 : viewport.clientWidth) !== null && _viewport$clientWidth2 !== void 0 ? _viewport$clientWidth2 : 1
      });
    };

    updateScrollState();
    viewport.addEventListener("scroll", updateScrollState, {
      passive: true
    });
    window.addEventListener("resize", updateScrollState);
    return function () {
      viewport.removeEventListener("scroll", updateScrollState);
      window.removeEventListener("resize", updateScrollState);
    };
  }, [viewport]);
  (0, _useMutationObserver.useMutationObserver)({
    element: viewport,
    onMutate: function onMutate(mutations) {
      var _viewport$scrollLeft3, _viewport$scrollWidth3, _viewport$clientWidth3; // Check to see if any of the mutations has either added or removed nodes


      var hasMeaningfullyMutated = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
      }); // Only update scroll state if something was added or removed

      if (!hasMeaningfullyMutated) return;
      setScrollState({
        scrollLeft: (_viewport$scrollLeft3 = viewport === null || viewport === void 0 ? void 0 : viewport.scrollLeft) !== null && _viewport$scrollLeft3 !== void 0 ? _viewport$scrollLeft3 : 0,
        scrollWidth: (_viewport$scrollWidth3 = viewport === null || viewport === void 0 ? void 0 : viewport.scrollWidth) !== null && _viewport$scrollWidth3 !== void 0 ? _viewport$scrollWidth3 : 1,
        clientWidth: (_viewport$clientWidth3 = viewport === null || viewport === void 0 ? void 0 : viewport.clientWidth) !== null && _viewport$clientWidth3 !== void 0 ? _viewport$clientWidth3 : 1
      });
    }
  });
  (0, _useDragScroll.useDragScroll)({
    viewport: viewport,
    thumbRef: thumbRef,
    clientWidth: clientWidth,
    scrollWidth: scrollWidth,
    scrollLeft: scrollLeft,
    trackWidth: trackWidth
  });
  (0, _useClickScroll.useClickScroll)({
    viewport: viewport,
    thumbRef: thumbRef,
    trackRef: trackRef,
    scrollWidth: scrollWidth,
    trackWidth: trackWidth
  });
  return /*#__PURE__*/_react.default.createElement(Track, _extends({
    ref: trackRef,
    bg: "black15",
    role: "scrollbar",
    "aria-orientation": "vertical",
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": progress
  }, rest), /*#__PURE__*/_react.default.createElement(TrackHitArea, null), requiresScrolling && /*#__PURE__*/_react.default.createElement(Thumb, {
    position: "relative",
    bg: "black60",
    height: "100%",
    borderRadius: 3,
    width: thumbWidth,
    style: {
      transform: "translateX(".concat(thumbOffset, "px)"),
      backfaceVisibility: "hidden"
    }
  }, /*#__PURE__*/_react.default.createElement(HitArea, {
    ref: thumbRef,
    tabIndex: -1
  })));
});

exports.ShelfScrollBar = ShelfScrollBar;
ShelfScrollBar.displayName = "ShelfScrollBar";
var Track = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "ShelfScrollBar__Track",
  componentId: "iwm55u-0"
})(["position:relative;height:3px;width:100%;"]);
var TrackHitArea = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "ShelfScrollBar__TrackHitArea",
  componentId: "iwm55u-1"
})(["position:absolute;top:-10px;bottom:-10px;right:0;left:0;width:100%;"]);
var Thumb = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "ShelfScrollBar__Thumb",
  componentId: "iwm55u-2"
})([""]);
var HitArea = (0, _styledComponents.default)(_Clickable.Clickable).withConfig({
  displayName: "ShelfScrollBar__HitArea",
  componentId: "iwm55u-3"
})(["position:absolute;top:-10px;bottom:-10px;width:100%;left:0;opacity:0;transition:opacity 250ms;&:hover{opacity:1;}&:after{content:\"\";display:block;position:absolute;left:0;width:100%;background-color:", ";top:50%;margin-top:-1.5px;height:3px;}"], (0, _themeGet.themeGet)("colors.black100"));

var buildScrollBar = function buildScrollBar(_ref2) {
  var trackWidth = _ref2.trackWidth,
      scrollLeft = _ref2.scrollLeft,
      scrollWidth = _ref2.scrollWidth,
      clientWidth = _ref2.clientWidth;
  var progress = scrollLeft / (scrollWidth - clientWidth || 1) * 100; // Sets up a scrollbar for viewport

  var percentageVisible = clientWidth / scrollWidth;
  var thumbWidth = percentageVisible * clientWidth;
  var percentageOffset = scrollLeft / (scrollWidth - clientWidth || 1); // Transform it down to whatever our actual track width is as
  // it's always smaller than the target viewport.

  var normalizedThumbWidth = thumbWidth * trackWidth / clientWidth;
  var normalizedThumbOffset = percentageOffset * (trackWidth - normalizedThumbWidth);
  var requiresScrolling = percentageVisible < 1;
  return {
    requiresScrolling: requiresScrolling,
    progress: progress,
    percentageVisible: percentageVisible,
    percentageOffset: percentageOffset,
    thumbWidth: normalizedThumbWidth,
    thumbOffset: normalizedThumbOffset
  };
};

exports.buildScrollBar = buildScrollBar;